import React, { ReactElement } from "react";

type IconProps = {
  width?: number;
  height?: number;
  className?: string;
};

export default function ResetIcon(props: IconProps): ReactElement {
  const { width = 24, height = 24, className = "" } = props;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M8.77564 8.77183L7.75804 7.75423C10.2564 5.25582 14.43 5.42622 16.7004 8.26542C18.4308 10.4278 18.4308 13.5622 16.7004 15.727C14.6484 18.2926 11.0436 18.6814 8.52364 16.8886C8.04604 16.5502 7.39324 16.603 6.98044 17.0182C6.46204 17.5366 6.51724 18.403 7.11244 18.8302C10.5492 21.2926 15.438 20.8486 18.3516 17.4982C21.0732 14.3686 21.0732 9.62863 18.3516 6.49663C15.1284 2.78863 9.47884 2.64223 6.06364 6.05743L5.04604 5.03983C4.76524 4.75903 4.28764 4.91983 4.23244 5.31103L3.61084 9.66703C3.56524 9.98383 3.83644 10.255 4.15324 10.2094L8.50924 9.58783C8.90044 9.53262 9.06124 9.05263 8.78044 8.77423L8.77564 8.77183Z"
        fill="#878787"
      />
    </svg>
  );
}
